// extracted by mini-css-extract-plugin
module.exports = {"card":"placementSliderCard_card__3E4Uu","img":"placementSliderCard_img__1zZOW","radius":"placementSliderCard_radius__2ywBx","content":"placementSliderCard_content__1Nc11","title":"placementSliderCard_title__3Jpkl","address":"placementSliderCard_address__3NvSO"};
    if(module.hot) {
      // 1744882515954
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  